// JsFromRoutes CacheKey e02d932b55b06dc2d77b10b52d5b8efa
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  createMessage: /* #__PURE__ */ definePathHelper('post', '/:account_id/inbox/:inbox_id/scream/:id/messages'),
  close: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inbox/:inbox_id/scream/:id/close'),
  reopen: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inbox/:inbox_id/scream/:id/reopen'),
  typing: /* #__PURE__ */ definePathHelper('post', '/:account_id/inbox/:inbox_id/scream/:id/typing'),
  updateSubject: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inbox/:inbox_id/scream/:id/update_subject'),
  archive: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inbox/:inbox_id/scream/:id/archive'),
  unarchive: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inbox/:inbox_id/scream/:id/unarchive'),
  markAsSpam: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inbox/:inbox_id/scream/:id/mark_as_spam'),
  unmarkAsSpam: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inbox/:inbox_id/scream/:id/unmark_as_spam'),
  markAsUnread: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inbox/:inbox_id/scream/:id/mark_as_unread'),
  toggleLiveTranslate: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inbox/:inbox_id/scream/:id/toggle_live_translate'),
  assign: /* #__PURE__ */ definePathHelper('patch', '/:account_id/inbox/:inbox_id/scream/:id/assign'),
  sendTranscript: /* #__PURE__ */ definePathHelper('post', '/:account_id/inbox/:inbox_id/scream/:id/send_transcript'),
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/inbox/:inbox_id/scream'),
  new: /* #__PURE__ */ definePathHelper('get', '/:account_id/inbox/:inbox_id/scream/new'),
  show: /* #__PURE__ */ definePathHelper('get', '/:account_id/inbox/:inbox_id/scream/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/inbox/:inbox_id/scream/:id'),
}
